// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar {
  background-color: var(--navbar-bg-color);
  width: 100%;
  display: flex;
  flex-direction: column;
}
.navbar__logo img {
  height: var(--navbar-logo-height-mobile);
  display: block;
}
@media (min-width: 1200px) {
  .navbar__logo img {
    height: var(--navbar-logo-height-desktop);
  }
}
.navbar__logo--desktop {
  display: none;
}
.navbar__logo--mobile {
  display: block;
}
@media (min-width: 1200px) {
  .navbar__logo--desktop {
    display: block;
  }
  .navbar__logo--mobile {
    display: none;
  }
}
.navbar__actions {
  display: flex;
  margin-left: auto;
  gap: 0.5rem;
  min-height: 36px;
  min-width: 0;
  align-items: center;
}
.navbar__menu {
  display: flex;
  margin-left: auto;
  align-items: center;
}
.navbar__container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.navbar-login-button {
  background-color: var(--login-header-button-bg-color) !important;
  color: var(--login-header-button-color) !important;
  border-color: var(--login-header-button-border-color) !important;
}
.navbar-login-button:hover {
  background-color: var(--login-header-button-bg-color-hover) !important;
  color: var(--login-header-button-color-hover) !important;
  border-color: var(--login-header-button-border-color-hover) !important;
}
.navbar-register-button {
  background-color: var(--register-header-button-bg-color) !important;
  color: var(--register-header-button-color) !important;
  border-color: var(--register-header-button-border-color) !important;
}
.navbar-register-button:hover {
  background-color: var(--register-header-button-bg-color-hover) !important;
  color: var(--register-header-button-color-hover) !important;
  border-color: var(--register-header-button-border-color-hover) !important;
}
.navbar-logout-button, .navbar-logout-button__confirm-button {
  background-color: var(--login-header-button-bg-color) !important;
  color: var(--login-header-button-color) !important;
  border-color: var(--login-header-button-border-color) !important;
}
.navbar-logout-button:hover, .navbar-logout-button__confirm-button:hover {
  background-color: var(--login-header-button-bg-color-hover) !important;
  color: var(--login-header-button-color-hover) !important;
  border-color: var(--login-header-button-border-color-hover) !important;
}
.navbar__anchor-links-desktop {
  margin-right: 3px;
  margin-left: 20px;
}
@media (max-width: 1199px) {
  .navbar__anchor-links-desktop {
    display: none;
  }
}
.navbar__anchor-link {
  color: var(--navbar-anchor-link-color) !important;
}
@media (min-width: 1200px) {
  .navbar__anchor-drawer {
    display: none;
  }
}
.navbar__anchor-drawer .ant-drawer-content-wrapper {
  top: var(--navbar-height-mobile);
  box-shadow: none !important;
}
.navbar__anchor-drawer .ant-drawer-mask {
  top: var(--navbar-height-mobile);
}
.navbar__anchor-drawer-burger-button {
  margin-bottom: 3px;
}
@media (min-width: 1200px) {
  .navbar__anchor-drawer-burger-button {
    display: none;
  }
}
.navbar__anchor-drawer-buttons-container {
  width: 100%;
  padding-bottom: 5px;
}
@media (max-width: 1199px) {
  .navbar .hide-on-mobile {
    display: none;
  }
}

.affix {
  position: static;
  z-index: 2;
  width: 100%;
}
.affix .ant-affix {
  z-index: 2;
}
.affix .navbar {
  transition: background-color 0.5s ease, box-shadow 0.3s ease;
}
.affix .navbar .hamburger-icon span {
  background-color: var(--navbar-home-hamburger-menu-color) !important;
}
.affix .navbar--affixed {
  background-color: var(--navbar-scrolled-bg-color);
  box-shadow: rgb(89, 95, 98) 0 0.25rem 1rem -0.25rem;
}
.affix .navbar--affixed .navbar__anchor-link {
  color: var(--navbar-scrolled-anchor-link-color) !important;
}
.affix .navbar--affixed .hamburger-icon span {
  background-color: var(--navbar-home-scrolled-hamburger-menu-color) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/blocks/Navbar/Navbar.scss"],"names":[],"mappings":"AAEA;EACI,wCAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;AADJ;AAIQ;EACI,wCAAA;EACA,cAAA;AAFZ;AAIY;EAJJ;IAKQ,yCAAA;EADd;AACF;AAIQ;EACI,aAAA;AAFZ;AAKQ;EACI,cAAA;AAHZ;AAMQ;EACI;IACI,cAAA;EAJd;EAOU;IACI,aAAA;EALd;AACF;AASI;EACI,aAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;AAPR;AAUI;EACI,aAAA;EACA,iBAAA;EACA,mBAAA;AARR;AAWI;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;AATR;AAYI;EACI,gEAAA;EACA,kDAAA;EACA,gEAAA;AAVR;AAYQ;EACI,sEAAA;EACA,wDAAA;EACA,sEAAA;AAVZ;AAcI;EACI,mEAAA;EACA,qDAAA;EACA,mEAAA;AAZR;AAcQ;EACI,yEAAA;EACA,2DAAA;EACA,yEAAA;AAZZ;AAgBI;EAEI,gEAAA;EACA,kDAAA;EACA,gEAAA;AAfR;AAiBQ;EACI,sEAAA;EACA,wDAAA;EACA,sEAAA;AAfZ;AAmBI;EACI,iBAAA;EACA,iBAAA;AAjBR;AAkBQ;EAHJ;IAIQ,aAAA;EAfV;AACF;AAkBI;EACI,iDAAA;AAhBR;AAoBQ;EADJ;IAEQ,aAAA;EAjBV;AACF;AAmBQ;EACI,gCAAA;EACA,2BAAA;AAjBZ;AAoBQ;EACI,gCAAA;AAlBZ;AAsBI;EACI,kBAAA;AApBR;AAsBQ;EAHJ;IAIQ,aAAA;EAnBV;AACF;AAsBI;EACI,WAAA;EACA,mBAAA;AApBR;AAwBQ;EADJ;IAEQ,aAAA;EArBV;AACF;;AAyBA;EACI,gBAAA;EACA,UAAA;EACA,WAAA;AAtBJ;AAwBI;EACI,UAAA;AAtBR;AAyBI;EACI,4DAAA;AAvBR;AAyBQ;EACI,oEAAA;AAvBZ;AA0BQ;EACI,iDAAA;EACA,mDAAA;AAxBZ;AA0BY;EACI,0DAAA;AAxBhB;AA2BY;EACI,6EAAA;AAzBhB","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
